// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"326":"4e460c15","453":"5a8b46da","676":"8a6d1770","924":"b4e732fe","986":"8f481064"}[chunkId] + ".chunk.js";
};